import React from "react";
import PropTypes from "prop-types";

import Header from "./Header";
import Configuration from "./Configuration";

const LeftSide = ({ isEdit }) => {
  return (
    <div className="theme-builder-left-side">
      <Header />
      <Configuration isEdit={isEdit} />
    </div>
  );
};

LeftSide.propTypes = {
  isEdit: PropTypes.bool,
};

export default LeftSide;
